<div class="footer">
    <p style="padding-left: 269px; padding-top: 17px;font-size: 17px;">Copyright @ 2020 All Rights Reserved</p>
  </div>